import { P } from 'components'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLazyFindAddressBookQuery } from '../addressBookApiSlice'
import PMBSelect from 'components/PMBSelect'

const DropdownAddressBook = ({
  title = 'Penjual',
  placeholderDesc = 'Cari Penjual',
  isRequired = false,
  isPhoneUnRegistered = false,
  isPhoneRegistered = false,
  isEmailUnRegistered = false,
  isEmailRegistered = false,
  isPhoneVerified = false,
  isEmailVerified = false,
  isHarvester = false,
  isLandOwner = false,
  isRecentTrx = false,
  onSelectContact,
  isUppercaseValue,
  fieldName,
  editValue,
  isVessel,
  onFetchingChange,
  className,
  valueName,
  data,
  isLoading,
}) => {
  const { profile } = useSelector((s) => s.dashboard)

  const [localSearch, setLocalSearch] = useState(null)
  const [addressBookData, setAddressBookData] = useState([])
  const [recentData, setRecentData] = useState([])
  const [isFetchingLocal, setIsFetchingLocal] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [fetchAddressBook] = useLazyFindAddressBookQuery()

  const handleSelectContact = (contact) => {
    if (contact?.value === '__load_more__') {
      const nextPage = Math.floor(addressBookData.length / 10)
      handleInitialFetch(nextPage, true)
      setMenuOpen(true)
      return
    }

    const relationName = isUppercaseValue
      ? contact?.relationName?.toUpperCase()
      : contact?.relationName

    const displayText = data
      ? (contact?.label ?? contact?.partnership?.name ?? contact?.fullName)
      : contact?.relationPhoneNumber
        ? `${relationName} (${contact?.relationPhoneNumber})`
        : contact?.relationEmail
          ? `${relationName} (${contact?.relationEmail})`
          : relationName

    setLocalSearch({
      label: displayText,
      value:
        contact?.value ??
        contact?.userId ??
        contact?.relationUserId ??
        contact?.relationEmailUserId,
    })
    if (onSelectContact) {
      onSelectContact(contact, fieldName)
    }
  }

  const handleInitialFetch = async (page = 0, append = false) => {
    setIsFetchingLocal(true)

    try {
      const response = await fetchAddressBook({
        s: '',
        size: 10,
        page,
        sortby: 'createdAt',
        sortdir: 'desc',
        ...(isPhoneUnRegistered && { isPhoneUnRegistered }),
        ...(isPhoneRegistered && { isPhoneRegistered }),
        ...(isEmailUnRegistered && { isEmailUnRegistered }),
        ...(isEmailRegistered && { isEmailRegistered }),
        ...(isPhoneVerified && { isPhoneVerified }),
        ...(isEmailVerified && { isEmailVerified }),
        ...(isHarvester && { isHarvester }),
        ...(isLandOwner && { isLandOwner }),
      }).unwrap()

      const modifyResponse = response?.items?.map((e) => ({
        ...e,
        value: e?.relationUserId ?? e?.relationEmailUserId,
        label: `${e?.relationName} (${e?.relationPhoneNumber ?? e?.relationEmail})`,
      }))

      let currentData = append
        ? [...addressBookData.filter((d) => d.value !== '__load_more__')]
        : []

      let data = [...currentData, ...(modifyResponse || [])]

      if ((page + 1) * 10 < (response?.totalItems || 0)) {
        data = [
          ...data,
          { value: '__load_more__', label: 'Lihat lebih banyak...' },
        ]
      }

      if (isRecentTrx && page === 0) {
        const recent = JSON.parse(
          localStorage.getItem(`savedContacts-${profile?.userId}`) || '[]',
        )
        const modifyrecent = recent.map((e) => ({
          profile_img: e?.profileImg,
          relationEmail: e?.email,
          relationName: e?.fullName,
          relationPhoneNumber: e?.phoneNumber,
          relationUserId: e?.userId,
          value: e?.relationUserId ?? e?.relationEmailUserId ?? e?.userId,
          label: `${e?.fullName} (${e?.phoneNumber ?? e?.email})`,
          ...e,
        }))

        setRecentData([...(modifyrecent || [])])
        setAddressBookData(data)
      } else {
        setAddressBookData(data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      setIsFetchingLocal(false)
    }
  }

  useEffect(() => {
    return () => {
      setLocalSearch(null)
      setAddressBookData([])
    }
  }, [])

  useEffect(() => {
    if (editValue) {
      setLocalSearch(editValue)
    } else {
      setLocalSearch(null)
    }
  }, [editValue])

  useEffect(() => {
    if (valueName) {
      setLocalSearch(valueName)
    } else {
      setLocalSearch(null)
    }
  }, [valueName])

  useEffect(() => {
    if (onFetchingChange) {
      onFetchingChange(isFetchingLocal)
    }
  }, [isFetchingLocal, onFetchingChange])

  useEffect(() => {
    if (data) {
      setAddressBookData(data)
    } else {
      handleInitialFetch()
    }
  }, [data])

  return (
    <div style={{ position: 'relative' }} className="w-100">
      <P size={isVessel ? 'regular' : 'default'} className="mb-2">
        {title}
        {isRequired && <span className="text-danger">*</span>}
      </P>
      <PMBSelect
        options={
          isRecentTrx
            ? [
                {
                  label: 'YANG SERING/TERAKHIR DIPILIH',
                  options: recentData,
                },
                {
                  label: 'SEMUA KONTAK',
                  options: addressBookData,
                },
              ]
            : addressBookData
        }
        placeholder={placeholderDesc}
        isLoading={isLoading || isFetchingLocal}
        onChange={handleSelectContact}
        value={localSearch}
        isClearable
        menuIsOpen={menuOpen}
        onMenuOpen={() => setMenuOpen(true)}
        onMenuClose={() => setMenuOpen(false)}
      />
    </div>
  )
}

export default DropdownAddressBook
